import { __ } from '@wordpress/i18n';
import { GoVideo } from "react-icons/go";
import { FaFileVideo, FaYoutube, FaVimeoV } from "react-icons/fa";

export const VariationPicker = ({ onChange }) => {
    return (
        <div className="vb-video-variation">
            <span className="vb-video-variation-icon">
                <GoVideo />
                <span className="vb-video-variation-heading">Video Type</span>
            </span>
            <span className="vb-video-variation-para">Select Video Type</span>

            <div className="vb-video-variation-child">
                <div className="vb-video-variation-card" onClick={() => onChange('mp4')}>
                    <FaFileVideo size={28} />
                    <span>MP4</span>
                </div>
                <div className="vb-video-variation-card" onClick={() => onChange('you-tube')}>
                    <FaYoutube size={28} color="#FF0000" />
                    <span>YouTube</span>
                </div>
                <div className="vb-video-variation-card" onClick={() => onChange('vimeo')}>
                    <FaVimeoV size={28} color="#1ab7ea" />
                    <span>Vimeo</span>
                </div>
            </div>
        </div>
    );
};
